import {country} from "../data/Country";

export const CUSTOMER_ADDRESS_TYPE = {
    ADDRESS: "ADDRESS",
    RESIDENTIAL_ADDRESS: "RESIDENTIAL_ADDRESS",
};

const formatAddressPart = (value, {prefix, pattern}) => {
    const trimmed = String(value ?? "").trim();
    if (!trimmed) {
        return "";
    }
    if (pattern?.test(trimmed)) {
        return trimmed;
    }
    return `${prefix} ${trimmed}`;
};

export const hasAddressContent = (value) => {
    if (value == null || value === "") {
        return false;
    }
    if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed !== "" && trimmed !== "-";
    }
    return [
        value.street,
        value.houseNumber,
        value.building,
        value.roomNumber,
        value.locality,
    ].some((part) => String(part ?? "").trim() !== "");
};

export const formatAddressValue = (value) => {
    if (!hasAddressContent(value)) {
        return "";
    }
    if (typeof value === "string") {
        return value.trim();
    }

    const parts = [
        value.country ? (country[value.country] ?? value.country) : "",
        value.street
            ? formatAddressPart(value.street, {prefix: "ул.", pattern: /^ул\.?\s/i})
            : "",
        value.houseNumber
            ? formatAddressPart(value.houseNumber, {prefix: "д.", pattern: /^д\.?\s/i})
            : "",
        value.building
            ? formatAddressPart(value.building, {prefix: "корп.", pattern: /^корп\.?\s/i})
            : "",
        value.roomNumber
            ? formatAddressPart(value.roomNumber, {prefix: "кв.", pattern: /^кв\.?\s/i})
            : "",
    ].filter(Boolean);

    return parts.join(", ");
};

export const formatAddressOptionLabel = (option) => {
    if (!option) {
        return "";
    }

    const formatted = formatAddressValue(option);
    if (formatted) {
        return formatted;
    }

    const parts = [
        option.locality,
        option.districts,
        option.region,
        option.republic,
        option.territory,
        option.postalcode,
    ].filter((part) => String(part ?? "").trim() !== "");

    if (parts.length > 0) {
        return parts.join(", ");
    }

    return option.id != null ? `Адрес #${option.id}` : "";
};

export const getEmptyAddressFormState = () => ({
    postalcode: "",
    country: "",
    republic: "",
    territory: "",
    region: "",
    districts: "",
    locality: "",
    street: "",
    houseNumber: "",
    building: "",
    roomType: "",
    roomNumber: "",
    latitude: "",
    longitude: "",
    additionalInfo: "",
});

export const getDefaultAddressFormState = () => {
    const [[defaultCountry]] = Object.entries(country);
    return {
        ...getEmptyAddressFormState(),
        country: defaultCountry,
    };
};

export const addressRawToFormState = (raw) => {
    const defaults = getEmptyAddressFormState();
    if (!raw || typeof raw !== "object") {
        return defaults;
    }
    return {
        ...defaults,
        ...raw,
        id: raw.id,
    };
};

export const getAddressTypeForFieldKey = (fieldKey) =>
    fieldKey === "residentialAddress"
        ? CUSTOMER_ADDRESS_TYPE.RESIDENTIAL_ADDRESS
        : CUSTOMER_ADDRESS_TYPE.ADDRESS;

export const getAddressFieldLabel = (fieldKey) =>
    fieldKey === "residentialAddress" ? "Адрес доставки" : "Адрес проживания";

export const getLinkedAddressId = (raw) =>
    hasAddressContent(raw) ? raw.id : null;

export const buildCustomerAddressLinkPayload = (
    fieldKey,
    selectedAddressId,
    {addressRaw, residentialAddressRaw},
) => {
    const addressId = fieldKey === "address"
        ? selectedAddressId
        : getLinkedAddressId(addressRaw);
    const residentialAddressId = fieldKey === "residentialAddress"
        ? selectedAddressId
        : getLinkedAddressId(residentialAddressRaw);

    return {
        address: {id: addressId},
        residentialAddress: {id: residentialAddressId},
    };
};
